import { UnknownAction } from 'redux';
import {
  ClaimActionTypes,
  FETCH_CLAIMS_REQUEST,
  FETCH_CLAIMS_SUCCESS,
  FETCH_CLAIMS_FAILURE,
  CREATE_CLAIM_REQUEST,
  CREATE_CLAIM_SUCCESS,
  CREATE_CLAIM_FAILURE,
  UPDATE_CLAIM_REQUEST,
  UPDATE_CLAIM_SUCCESS,
  UPDATE_CLAIM_FAILURE,
  DELETE_CLAIM_REQUEST,
  DELETE_CLAIM_SUCCESS,
  DELETE_CLAIM_FAILURE,
  SET_CLAIM_SEARCH_TERM,
  SET_CLAIM_CURRENT_PAGE,
} from '../actions/claimActions';
import { ClaimData, PaginationData } from '../../services/types';

export interface ClaimState {
  claims: ClaimData[];
  pagination: PaginationData | null;
  loading: boolean;
  error: string | null;
  searchTerm: string;
  currentPage: number;
  creating: boolean;
  updating: boolean;
  deleting: boolean;
}

const initialState: ClaimState = {
  claims: [],
  pagination: null,
  loading: false,
  error: null,
  searchTerm: '',
  currentPage: 1,
  creating: false,
  updating: false,
  deleting: false,
};

const claimReducer = (state = initialState, action: UnknownAction): ClaimState => {
  const typedAction = action as ClaimActionTypes;
  switch (typedAction.type) {
    case FETCH_CLAIMS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_CLAIMS_SUCCESS:
      return {
        ...state,
        loading: false,
        claims: typedAction.payload.claims,
        pagination: typedAction.payload.pagination,
        error: null,
      };

    case FETCH_CLAIMS_FAILURE:
      return {
        ...state,
        loading: false,
        error: typedAction.payload,
        claims: [],
      };

    case CREATE_CLAIM_REQUEST:
      return {
        ...state,
        creating: true,
        error: null,
      };

    case CREATE_CLAIM_SUCCESS:
      return {
        ...state,
        creating: false,
        error: null,
      };

    case CREATE_CLAIM_FAILURE:
      return {
        ...state,
        creating: false,
        error: typedAction.payload,
      };

    case UPDATE_CLAIM_REQUEST:
      return {
        ...state,
        updating: true,
        error: null,
      };

    case UPDATE_CLAIM_SUCCESS:
      return {
        ...state,
        updating: false,
        error: null,
        // Update the claim in the list - handle both string and number IDs
        claims: state.claims.map(claim =>
          String(claim.id) === String(typedAction.payload.id) ? typedAction.payload : claim
        ),
      };

    case UPDATE_CLAIM_FAILURE:
      return {
        ...state,
        updating: false,
        error: typedAction.payload,
      };

    case DELETE_CLAIM_REQUEST:
      return {
        ...state,
        deleting: true,
        error: null,
      };

    case DELETE_CLAIM_SUCCESS:
      return {
        ...state,
        deleting: false,
        error: null,
        // Remove the claim from the list - handle both string and number IDs
        claims: state.claims.filter(claim => String(claim.id) !== String(typedAction.payload)),
      };

    case DELETE_CLAIM_FAILURE:
      return {
        ...state,
        deleting: false,
        error: typedAction.payload,
      };

    case SET_CLAIM_SEARCH_TERM:
      return {
        ...state,
        searchTerm: typedAction.payload,
        currentPage: 1,
      };

    case SET_CLAIM_CURRENT_PAGE:
      return {
        ...state,
        currentPage: typedAction.payload,
      };

    default:
      return state;
  }
};

export default claimReducer;

